<div class="main-container lg-view">
  <h3>This Procedure Step Confirmation link has Expired</h3>
  <div class="refresh-link-container">
	<h4>Please request a new one to continue</h4>
    <button mat-raised-button  (click)="onRefreshLinkClick()" [disabled]="isLinkRefreshed">
      <span *ngIf="!isLinkRefreshed">Refresh Link</span>
	  <span *ngIf="isLinkRefreshed">Link Refreshed</span>
    </button>
	<ng-container *ngIf="isLinkRefreshed" class="confirmation-message">
	  <h4>A new confirmation link has been sent</h4>
	  <h4>Please check your email and/or SMS messages for the updated link.</h4>
	</ng-container>
  </div>
</div>
